import { Reveal } from "./Reveal";

const LEADERS = [
  { name: "Johnathan E. Sanders, I", role: "Senior Pastor" },
  { name: "Kimberly R. Sanders", role: "Co-Pastor" },
];

export default function Pastors() {
  return (
    <section id="pastors" data-testid="pastors-section" className="relative py-28 md:py-40 bg-[#0a0a0a] border-y border-white/10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-[#4169E1] mb-6">Our Leadership</p>
          <h2 className="font-display font-bold uppercase tracking-tighter leading-none text-4xl sm:text-5xl md:text-6xl">
            Shepherds of the house
          </h2>
        </Reveal>

        <div className="mt-20 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <Reveal className="lg:col-span-7">
            <div
              data-testid="pastors-portrait"
              className="group relative overflow-hidden rounded-sm border border-white/10 aspect-[4/5] max-h-[80vh] w-full"
            >
              <img
                src="/pastors-sanders.webp"
                alt="Senior Pastor Johnathan E. Sanders, I and Co-Pastor Kimberly R. Sanders"
                className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 group-hover:scale-105 transition-[transform,filter] duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
              <p className="absolute bottom-6 left-6 text-xs uppercase tracking-[0.3em] text-zinc-300">
                Pastor &amp; First Lady Sanders
              </p>
            </div>
          </Reveal>

          <div className="lg:col-span-5">
            {LEADERS.map((l, i) => (
              <Reveal key={l.name} delay={0.15 + i * 0.15}>
                <div
                  data-testid={`pastor-card-${i}`}
                  className={`group py-10 ${i === 0 ? "border-b border-white/10" : ""}`}
                >
                  <p className="text-xs uppercase tracking-[0.3em] text-[#4169E1] mb-3">{l.role}</p>
                  <h3 className="font-display font-semibold uppercase tracking-tight text-3xl sm:text-4xl group-hover:text-[#4169E1] transition-colors duration-500">
                    {l.name}
                  </h3>
                </div>
              </Reveal>
            ))}
            <Reveal delay={0.45}>
              <p className="mt-8 text-sm md:text-base text-zinc-400 leading-relaxed">
                Together they lead Hyde Park Victory Church with a heart for Presidential Hills —
                reaching the lost, teaching the believers, and empowering disciples to reach others.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
